import { z } from "zod";

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email address is required")
    .email("Invalid email address"),
});

export const otpVerifySchema = z.object({
  otp: z.string().trim().min(6, "OTP must be at least 6 digits"),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().min(8, "Password must be at least 8 characters"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>;
export type OtpVerifyValues = z.infer<typeof otpVerifySchema>;
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;
